<template>
  <div class="detail">
    <div class="header">
      <div class="left" @click="toIndex()">< 返回</div>
      <div class="span1">
        <span>{{ info.courseName }} 学生出勤详情</span>
      </div>
      <div class="right"></div>
    </div>
    <div>
      <el-form ref="form" :inline="true" :model="queryParams" label-width="90px">
        <el-form-item label="">
          <el-select v-model="queryParams.semester" placeholder="选择学年学期" class="label">
            <el-option v-for="item in semesterList" :key="item.id" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select
            v-model="queryParams.campusId"
            clearable
            placeholder="选择校区"
            class="label"
          >
            <el-option
              v-for="item in campusList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select
            v-model="queryParams.gradeId"
            clearable
            placeholder="选择年级"
            class="label"
          >
            <el-option
              v-for="item in gradeList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select
            v-model="queryParams.classId"
            clearable
            placeholder="选择班级"
            class="label"
          >
            <el-option
              v-for="item in classList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-input
            v-model="queryParams.studentName"
            clearable
            placeholder="请输入学生姓名"
          />
        </el-form-item>
        <!-- <el-form-item label="">
           <el-date-picker
                style="width:275px"
                v-model="queryParams.selectData"
                :picker-options="pickerOptions"
                type="week"
                :format="queryParams.startDate + '到' + queryParams.endDate + '第 WW 周'"
                placeholder="选择周"
                @change="customTimeSure"
              >
            </el-date-picker>
        </el-form-item> -->
        <el-form-item label="">
          <el-button type="primary" size="small" @click="getDataList()">搜索</el-button>
        </el-form-item>
      </el-form>

      <!-- 校内教师 -->
      <div class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="studentName" label="学生姓名" align="center">
          </el-table-column>
          <el-table-column prop="className" label="班级" align="center">
          </el-table-column>
          <el-table-column
            prop="needAttendanceNum"
            label="应出勤次数"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="lateNum" label="迟到次数" align="center">
          </el-table-column>
          <el-table-column prop="leaveNum" label="请假次数" align="center">
          </el-table-column>
          <el-table-column
            prop="attendanceNum"
            label="实际出勤次数"
            align="center"
          >
          </el-table-column>
        </el-table>
        <div class="pagination">
          <!--分页组件-->
          <el-pagination
            background
            :current-page="pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :total="totalPage"
            layout="total,prev, pager, next,jumper,sizes"
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import api from "@/api/wisdomSchool/index";
export default {
  props: ["info",'semester','semesterList'],
  data() {
    return {
      queryParams: {
        campusId: "",
        semester: "",
        gradeId: "",
        classId: "",
        studentName: "",
        startDate: "",
        endDate: "",
        selectData:'',
      },
      pageNum: 1,
      pageSize: 10,
      totalPage: 10,
      campusList: [],
      gradeList: [],
      classList: [],
      tableData: [],
      school_info: JSON.parse(sessionStorage.getItem("classList"))||[],
      pickerOptions: {
          // disabledDate(time) {
          //   return time.getTime() > Date.now();
          // },
      },
    };
  },
  watch: {
    info:{
      handler(n,o){
        this.page = 1;
        this.queryParams.semester = this.semester;
        console.log('监听',this.semester)
        this.getDataList();
      },
      deep:true,
    },
    "queryParams.campusId": function (n, o) {
      this.queryParams.gradeId = "";
      this.queryParams.classId = "";
      this.gradeList = [];
      this.classList = [];
      this.gradeList =
        this.campusList.filter((v) => v.id === n)[0]?.children || [];
    },
    "queryParams.gradeId": function (n, o) {
      this.queryParams.classId = "";
      this.classList = [];
      this.classList =
        this.gradeList.filter((v) => v.id === n)[0]?.children || [];
    },
  },
  created() {
    this.campusList = this.school_info.slice();
  },
  methods: {
    async getDataList() {
      if(this.queryParams.selectData=='' || this.queryParams.selectData==null){
         this.queryParams.startDate=''
         this.queryParams.endDate=''
      }
      let params = {
        schoolYearSemester: this.queryParams.semester,
        courseApplyId: this.info.courseApplyId, //	否	string	开课申请Id
        classId:this.queryParams.classId ,
        gradeId:this.queryParams.gradeId ,
        campusId:this.queryParams.campusId ,
        schoolYearSemester: this.queryParams.schoolYearSemester,
        startDate: this.queryParams.startDate,
        endDate: this.queryParams.endDate,
        studentName: this.queryParams.studentName,
        orgId:sessionStorage.getItem('orgId'),
        platformCode:sessionStorage.getItem('platformCode'), 
        page: this.pageNum,
        limit: this.pageSize,
      };
      var { data, code } = await api.handleStudentAttendanceDetails(params);
      if (code == "0") {
        this.tableData = data.list;
        this.totalPage = data.total;
      }
    },
    searchFun(){
      this.pageNum=1;
			this.getDataList();
    },
    // 自定义时间过滤
    customTimeSure() {
        let that = this.queryParams;
      if (that.selectData) {
        that.startDate = dayjs(that.selectData)
          .startOf("week")
          .format("YYYY-MM-DD");
        that.endDate = dayjs(that.selectData)
          .endOf("week")
          .format("YYYY-MM-DD");
      }
    },
    sizeChangeHandle(val) {
      this.tableData = [];
      this.pageSize = val;
      this.getDataList();
    },

    currentChangeHandle(val) {
      this.tableData = [];
      this.pageNum = val;
      this.getDataList();
    },

    toIndex() {
      this.$emit("to-index");
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
      margin-right: 30px;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }

  ::v-deep .el-form .el-input__inner {
    // width: 189px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
